import React from 'react';
import styled from 'styled-components';
import { Switch as MuiSwitch } from '@material-ui/core';

const S = {
  Switch: styled(({ classes, ...otherProps }) => (
    <MuiSwitch
      classes={{
        ...classes,
        checked: 'checked',
        switchBase: 'switchBase',
        thumb: 'thumb',
        track: 'track',
      }}
      {...otherProps}
    />
  ))`
    align-items: center;
    width: 50px;
    height: 20px;
    padding: 0;
    .switchBase {
      position: static;
      transform: translateX(18px);
      padding: 1px;
    }
    .switchBase.checked {
      transform: translateX(32px);
      color: ${({ theme }) => theme.palette.common.white};
      + .track {
        background-color: ${({ theme }) => theme.palette.secondary.main};
        opacity: 1;
        border: none;
      }
    }
    .thumb {
      width: 12px;
      height: 12px;
    }
    .track {
      border-radius: 13px;
      background-color: ${({ theme }) => theme.palette.error.main};
      opacity: 1;
    }
  `,
};

/**
 * Switch를 사용하여 ON, OFF 상태를 전환할 수 있습니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
 */

const Switch = (props) => <S.Switch disableRipple {...props} />;

export default Switch;
